import React from "react";
import "./Divider.css";

function Divider() {
  return <div className="card__divider" />;
}

export default Divider;
